import React from "react";
import MainHeader from "../../components/pages/common/MainHeader";
import { AutomationWrapper } from "../../components/styleComponents";
import Sidebar from "../../components/pages/common/Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import { crmContent } from "./CrmContent";
import { Waypoint } from "react-waypoint";

export default function CrmLayout({handleWaypointEnter, handleWaypointLeave }) {
  const pathName = useLocation().pathname;
  const pathSegments = pathName.split("/");
  const key = pathSegments[1];
  const data = crmContent[key];
  return (
    <>
      <MainHeader heading="Automated CRM" />
			<Waypoint onEnter={handleWaypointEnter} onLeave={handleWaypointLeave} />
      <AutomationWrapper>
        <Sidebar data={data} url={key} />
        <Outlet />
      </AutomationWrapper>
    </>
  );
}
